import React, { useEffect, useRef, useState } from "react";
import {
  COST_CLASSIFICATION_DETAIL_PETTY_CASHIER,
  SUMMARY_PETTY_CASH_PETTY_CASHIER,
  VAT_REVIEW_REPORT_PETTY_CASHIER
} from "../../../../../constants/urls";
import {
  IMPREST_IDS,
  IMPREST_NUMBER,
  ROUTES,
  TYPE
} from "../../../../../constants/filters";
import { BoxLoading } from "../../../../../components/loading";
// import { MainContainer } from "../../../../../hocs/pettyCashTransactions/style";
import { PettyCashierPettyCashBudgetAction } from "../../../../../actions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { PETTY_CASHIER_SUMMARY_TRANSACTIONS_TABS } from "../../../../../constants/tabs";
import ErrorHandle from "../../../../../components/error/mainError";
import BudgetAccountTitleItem from "../../../../../projectSpecificComponents/budgetAccountTitle";
import { VAT_ID } from "../../../../../constants/transactionSubItems";
import {
  MESSAGE_FOR_CLICK_ON_COSTLESS_BUDGET_ACCOUNT_TITLE,
  WARNING_SINGLE_BUTTON_TEXT
} from "../../../../../constants/otherTexts";
import { Confirm } from "../../../../../components/confirm";
import {
  normalizeData,
  ACCOUNT_TITLE_BUDGET,
  ACCOUNT_TITLES_BUDGET_HEADER
} from "../../../../../hocs/summaryForm/components/table/normalizer";
import Table from "../../../../../hocs/summaryForm/components/table/table";

const INITIALIZED_WARNING = {
  show: false,
  message: ""
};

const usePrevious = value => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

const AccountTitleItems = props => {
  const [warning, setWarning] = useState(INITIALIZED_WARNING);

  const {
    data,
    loading,
    error,
    history,
    getList,
    topMargin,
    match: {
      params: { id }
    },
    pettyCashData
  } = props;

  const isFirstRender = useRef(true);
  const searchParam = new URLSearchParams(history.location.search);

  const getRequest = () => {
    const renderCondition =
      parseInt(searchParam.get(TYPE)) ===
      PETTY_CASHIER_SUMMARY_TRANSACTIONS_TABS.keys.ACCOUNT_TITLES;
    if (renderCondition) {
      getList(id);
    }
  };
  useEffect(() => {
    getRequest();
  }, []);

  const prevSearch = usePrevious(history.location.search);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    } else {
      if (prevSearch !== history.location.search) {
        if (
          history.location.pathname ===
          `${SUMMARY_PETTY_CASH_PETTY_CASHIER}/${id}` // when get file, route changed and if this condition is not checked, this scope runs
        ) {
          getRequest();
        }
      }
    }
  }, [history.location.search, data]);

  const onRowClickHandle = (accountTitleId, hasCost) => {
    if (hasCost) {
      if (accountTitleId === VAT_ID) {
        history.push({
          pathname: VAT_REVIEW_REPORT_PETTY_CASHIER,
          search: `?${IMPREST_IDS}=${id}&&${IMPREST_NUMBER}=${
            pettyCashData.imprest_number ? pettyCashData.imprest_number : ""
          }`
        });
      } else {
        history.push({
          pathname: COST_CLASSIFICATION_DETAIL_PETTY_CASHIER,
          search: `?${ROUTES}=${accountTitleId}.1&${IMPREST_IDS}=${id}&&${IMPREST_NUMBER}=${
            pettyCashData.imprest_number ? pettyCashData.imprest_number : ""
          }`
        });
      }
    } else {
      showWarning(MESSAGE_FOR_CLICK_ON_COSTLESS_BUDGET_ACCOUNT_TITLE);
    }
  };

  const showWarning = message => {
    setWarning({
      show: true,
      message: message
    });
    const route = {
      pathname: history.location.pathname,
      search: history.location.search
    };
    history.push(route);
  };
  const closeWarning = () => {
    setWarning(INITIALIZED_WARNING);
    history.goBack();
  };
  return (
    <React.Fragment>
      <Confirm
        show={warning.show}
        close={closeWarning}
        rejectHandler={closeWarning}
        content={{
          type: "warning",
          icon: "icon mapsa-notification",
          message: warning.message,
          rejectButtonText: WARNING_SINGLE_BUTTON_TEXT
        }}
      />
      {data.items && data.items.length > 0 && (
        <Table
          header={ACCOUNT_TITLES_BUDGET_HEADER}
          rowOnClick={item => {
            onRowClickHandle(item.account_title_id, item.cost_amount);
          }}
          hideColumn={() => !data.has_budget}
          data={normalizeData(data.items, ACCOUNT_TITLE_BUDGET)}
        />
      )}
      {loading && (
        <div className="page-loading-container ">
          <BoxLoading />
        </div>
      )}
      {!isFirstRender.current && error && (
        <ErrorHandle message={error} request={() => getList(id)} />
      )}
    </React.Fragment>
  );
};
const mapStateToProps = store => {
  const reducer = store.PettyCashierPettyCashBudget;
  return {
    data: reducer.itemData,
    loading: reducer.itemLoading,
    error: reducer.itemError,
    pettyCashData: store.PettyCashierPettyCash.selected
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getList: (filter, pageNumber) => {
      dispatch(
        PettyCashierPettyCashBudgetAction.showByAccountTitles(
          filter,
          pageNumber
        )
      );
    }
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AccountTitleItems));
